import {
	addDataApi,
	getAssetsApi,
	getDisplaysApi,
	getReasonApi,
	getConditionApi,
	updateDataApi,
} from '../../services/bToC/storeDisplay';
import { getErrorObject } from '../../utilities/utils';
import { IAddDataModel, IUpdateDataModel } from '../../models/storeDisplay';
import Constants from 'utilities/appConstants';
import { showMsgFromJson } from '../common';

export const types = {
	// Get Data
	RETAILER_GET_DATA_REQUEST: 'retailer/RETAILER_GET_DATA_REQUEST',
	RETAILER_GET_DATA_FAILURE: 'retailer/RETAILER_GET_DATA_FAILURE',
	RETAILER_GET_DATA_SUCCESS: 'retailer/RETAILER_GET_DATA_SUCCESS',
	// Add Data
	RETAILER_ADD_DATA_REQUEST: 'retailer/RETAILER_ADD_DATA_REQUEST',
	RETAILER_ADD_DATA_SUCCESS: 'retailer/RETAILER_ADD_DATA_SUCCESS',
	RETAILER_ADD_DATA_FAILURE: 'retailer/RETAILER_ADD_DATA_FAILURE',
	// Update Data
	RETAILER_UPDATE_DATA_REQUEST: 'retailer/RETAILER_UPDATE_DATA_REQUEST',
	RETAILER_UPDATE_DATA_SUCCESS: 'retailer/RETAILER_UPDATE_DATA_SUCCESS',
	RETAILER_UPDATE_DATA_FAILURE: 'retailer/RETAILER_UPDATE_DATA_FAILURE',
	// Get Reason
	RETAILER_GET_REASON_REQUEST: 'retailer/RETAILER_GET_REASON_REQUEST',
	RETAILER_GET_REASON_FAILURE: 'retailer/RETAILER_GET_REASON_FAILURE',
	RETAILER_GET_REASON_SUCCESS: 'retailer/RETAILER_GET_REASON_SUCCESS',
	// Get Condition
	RETAILER_GET_CONDITION_REQUEST: 'retailer/RETAILER_GET_CONDITION_REQUEST',
	RETAILER_GET_CONDITION_FAILURE: 'retailer/RETAILER_GET_CONDITION_FAILURE',
	RETAILER_GET_CONDITION_SUCCESS: 'retailer/RETAILER_GET_CONDITION_SUCCESS',
};

const initialState = {
	isDisplayLoading: false,
	isAssetLoading: false,
	displayList: [],
	assetList: [],
	displayCount: 0,
	assetCount: 0,
	error: null,
	reasonList: [],
	conditionList: [],
	isReasonListLoading: false,
	isConditionListLoading: false,
};

export const storeDisplay = (state = initialState, action) => {
	switch (action.type) {
		case types.RETAILER_GET_DATA_REQUEST:
		case types.RETAILER_GET_DATA_FAILURE:
		case types.RETAILER_GET_DATA_SUCCESS:
			return getDataReducer(state, action);
		case types.RETAILER_ADD_DATA_REQUEST:
		case types.RETAILER_ADD_DATA_SUCCESS:
		case types.RETAILER_ADD_DATA_FAILURE:
			return addDataReducer(state, action);
		case types.RETAILER_UPDATE_DATA_REQUEST:
		case types.RETAILER_UPDATE_DATA_SUCCESS:
		case types.RETAILER_UPDATE_DATA_FAILURE:
			return updateDataReducer(state, action);
		case types.RETAILER_GET_REASON_REQUEST:
		case types.RETAILER_GET_REASON_FAILURE:
		case types.RETAILER_GET_REASON_SUCCESS:
			return getReasonReducer(state, action);
		case types.RETAILER_GET_CONDITION_REQUEST:
		case types.RETAILER_GET_CONDITION_FAILURE:
		case types.RETAILER_GET_CONDITION_SUCCESS:
			return getConditionReducer(state, action);
		default:
			return state;
	}
};

const getDataReducer = (state, action) => {
	switch (action.type) {
		case types.RETAILER_GET_DATA_REQUEST:
			if (action.variant === Constants.BToC_CONTENT_VARIANT_DISPLAY) {
				return { ...state, isDisplayLoading: true };
			}
			return { ...state, isAssetLoading: true };
		case types.RETAILER_GET_DATA_SUCCESS:
			if (action.variant === Constants.BToC_CONTENT_VARIANT_DISPLAY) {
				return {
					...state,
					isDisplayLoading: false,
					error: null,
					displayList: [...action.payload],
					displayCount: Number(action.payload.length),
				};
			}
			return {
				...state,
				isAssetLoading: false,
				error: null,
				assetList: [...action.payload],
				assetCount: Number(action.payload.length),
			};
		case types.RETAILER_GET_DATA_FAILURE:
			return {
				...state,
				error: action.payload.error,
				isAssetLoading: false,
				isDisplayLoading: false,
			};
		default:
			return state;
	}
};

const addDataReducer = (state, action) => {
	switch (action.type) {
		case types.RETAILER_ADD_DATA_REQUEST:
			if (action.variant === Constants.BToC_CONTENT_VARIANT_DISPLAY) {
				return { ...state, isDisplayLoading: true };
			}
			return { ...state, isAssetLoading: true };
		case types.RETAILER_ADD_DATA_SUCCESS:
			if (action.variant === Constants.BToC_CONTENT_VARIANT_DISPLAY) {
				return {
					...state,
					isDisplayLoading: false,
					error: null,
					displayList: [...action.payload],
					displayCount: Number(action.payload.length),
				};
			}
			return {
				...state,
				isAssetLoading: false,
				error: null,
				assetList: [...action.payload],
				assetCount: Number(action.payload.length),
			};
		case types.RETAILER_ADD_DATA_FAILURE:
			return {
				...state,
				error: action.payload.error,
				isAssetLoading: false,
				isDisplayLoading: false,
			};
		default:
			return state;
	}
};

const updateDataReducer = (state, action) => {
	switch (action.type) {
		case types.RETAILER_UPDATE_DATA_REQUEST:
			if (action.variant === Constants.BToC_CONTENT_VARIANT_DISPLAY) {
				return { ...state, isDisplayLoading: true };
			}
			return { ...state, isAssetLoading: true };
		case types.RETAILER_UPDATE_DATA_SUCCESS:
			if (action.variant === Constants.BToC_CONTENT_VARIANT_DISPLAY) {
				return {
					...state,
					isDisplayLoading: false,
					error: null,
				};
			}
			return {
				...state,
				isAssetLoading: false,
				error: null,
			};
		case types.RETAILER_UPDATE_DATA_FAILURE:
			return {
				...state,
				error: action.payload.error,
				isAssetLoading: false,
				isDisplayLoading: false,
			};
		default:
			return state;
	}
};

const getReasonReducer = (state, action) => {
	switch (action.type) {
		case types.RETAILER_GET_REASON_REQUEST:
			return { ...state, isReasonListLoading: true };
		case types.RETAILER_GET_REASON_SUCCESS:
			return {
				...state,
				isReasonListLoading: false,
				error: null,
				reasonList: [...action.payload],
			};
		case types.RETAILER_GET_REASON_FAILURE:
			return {
				...state,
				error: action.payload.error,
				isReasonListLoading: false,
			};
		default:
			return state;
	}
};

const getConditionReducer = (state, action) => {
	switch (action.type) {
		case types.RETAILER_GET_CONDITION_REQUEST:
			return { ...state, isConditionListLoading: true };
		case types.RETAILER_GET_CONDITION_SUCCESS:
			return {
				...state,
				isConditionListLoading: false,
				error: null,
				conditionList: [...action.payload],
			};
		case types.RETAILER_GET_CONDITION_FAILURE:
			return {
				...state,
				error: action.payload.error,
				isConditionListLoading: false,
			};
		default:
			return state;
	}
};

export const getData = (type: string) => {
	return async (dispatch) => {
		dispatch({ type: types.RETAILER_GET_DATA_REQUEST, variant: type });
		let payload;
		try {
			if (type === Constants.BToC_CONTENT_VARIANT_DISPLAY) {
				const response = await getDisplaysApi();
				payload = response.data.Data;
			} else {
				const response = await getAssetsApi();
				payload = response.data.Data;
			}

			dispatch({ type: types.RETAILER_GET_DATA_SUCCESS, payload, variant: type });
		} catch (error) {
			dispatch(promiseCatchBlock(error, types.RETAILER_GET_DATA_FAILURE));
		}
	};
};

export const addData = (type: string, data: IAddDataModel) => {
	return async (dispatch) => {
		dispatch({ type: types.RETAILER_ADD_DATA_REQUEST, variant: type });
		let payload1;
		try {
			if (type === Constants.BToC_CONTENT_VARIANT_DISPLAY) {
				await addDataApi(data);

				const response = await getDisplaysApi();
				payload1 = response.data.Data;

				dispatch(showMsgFromJson(`store.display.successMessages.display`, Constants.SUCCESS));
			} else {
				await addDataApi(data);

				const response = await getAssetsApi();
				payload1 = response.data.Data;

				dispatch(showMsgFromJson(`store.display.successMessages.asset`, Constants.SUCCESS));
			}

			dispatch({ type: types.RETAILER_ADD_DATA_SUCCESS, payload: payload1, variant: type });
		} catch (error) {
			dispatch(promiseCatchBlock(error, types.RETAILER_ADD_DATA_FAILURE));
		}
	};
};

export const updateData = (type: string, data: IUpdateDataModel) => {
	return async (dispatch) => {
		dispatch({ type: types.RETAILER_UPDATE_DATA_REQUEST, variant: type });
		let payload;
		try {
			const response = await updateDataApi(data);
			/* Response toast message */
			if (response.data.Code)
				dispatch(showMsgFromJson(`common.alerts.success.${response.data.Code}`, Constants.SUCCESS));
			else dispatch(showMsgFromJson(`store.display.successMessages.update`, Constants.SUCCESS));

			dispatch({ type: types.RETAILER_UPDATE_DATA_SUCCESS, payload: payload, variant: type });
		} catch (error) {
			dispatch(promiseCatchBlock(error, types.RETAILER_UPDATE_DATA_FAILURE));
		}
	};
};

export const getReason = () => {
	return async (dispatch) => {
		dispatch({ type: types.RETAILER_GET_REASON_REQUEST });
		try {
			const response = await getReasonApi();
			const payload = response.data.Data;

			dispatch({ type: types.RETAILER_GET_REASON_SUCCESS, payload });
		} catch (error) {
			dispatch(promiseCatchBlock(error, types.RETAILER_GET_REASON_FAILURE));
		}
	};
};

export const getCondition = () => {
	return async (dispatch) => {
		dispatch({ type: types.RETAILER_GET_CONDITION_REQUEST });
		try {
			const response = await getConditionApi();
			const payload = response.data.Data;

			dispatch({ type: types.RETAILER_GET_CONDITION_SUCCESS, payload });
		} catch (error) {
			dispatch(promiseCatchBlock(error, types.RETAILER_GET_CONDITION_FAILURE));
		}
	};
};

const promiseCatchBlock = (error: any, type: string) => {
	return (dispatch) => {
		const { message } = getErrorObject(error);
		dispatch({
			type: type,
			payload: { error: message },
		});
	};
};
